const soundBackground = async() => {
  const path = `../assets/sound/Brendan_Kinsella_-_Mozart.mp3`;    
  var audio = new Audio(path);    
  audio.volume = 0.3;
  audio.loop = true;
  audio.play();
}

export default soundBackground;